import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

import {RootState} from '../../../index';
import {getMyTopPerformingGamesState} from '../../../selectors/fortnite-game/myTopPerformingGamesSelector';
import {MyTopPerformingGamesState} from '../../../reducers/fortnite-game/myTopPerformingGames.reducer';
import actionsTopPerformingGames from '../../../actions/fortnite-game/myTopPerformingGames.actions';
import {MyTopPerformingGame} from '../../../types';
import {getMappedGame} from '../Utils';

import useGamesData from '../../../pages/fortnite-games/useGamesData';

const useMyTopPerformingGamesData = (): MyTopPerformingGamesState => {
    const dispatch = useDispatch();

    const {
        data: {codeNamesMap},
        loading: gamesLoading
    } = useGamesData();

    const {mostPopularGame, highestGrowth, highestAvgPlayTime, mostVisitedGame} = useSelector<
        RootState,
        MyTopPerformingGamesState
    >(getMyTopPerformingGamesState, shallowEqual);

    useEffect(() => {
        const requests = [
            {value: MyTopPerformingGame.MOST_POPULAR_GAME},
            {value: MyTopPerformingGame.HIGHEST_GROWTH},
            {value: MyTopPerformingGame.HIGHEST_AVG_PLAY_TIME},
            {value: MyTopPerformingGame.MOST_VISITED_GAME}
        ];

        requests.forEach(params => {
            dispatch(
                actionsTopPerformingGames.getTopPerformingGames({
                    ...params
                })
            );
        });
    }, []);

    return {
        mostPopularGame: getMappedGame(codeNamesMap, mostPopularGame, gamesLoading),
        highestGrowth: getMappedGame(codeNamesMap, highestGrowth, gamesLoading),
        highestAvgPlayTime: getMappedGame(codeNamesMap, highestAvgPlayTime, gamesLoading),
        mostVisitedGame: getMappedGame(codeNamesMap, mostVisitedGame, gamesLoading)
    };
};

export default useMyTopPerformingGamesData;
